import AppLayout from "./AppLayout";
import AuthLayout from "./AuthLayout";
import EmptyLayout from "./EmptyLayout";
import TransferringLayout from "./TransferringLayout";

export const MasterLayout = {
  AppLayout,
  AuthLayout,
  TransferringLayout,
  EmptyLayout,
};
